import { UserRoleConstants } from "@/shared/Constants";

export const hasUserRole = (userRoles: string[] | undefined, target: string | undefined): boolean => {
  if (!userRoles || !target) return false;
  // Case-sensitive strict equality per requirements
  return userRoles.some((r) => r === target);
};

export const hasAnyRole = (userRoles: string[] | undefined, targets: string[] | undefined): boolean => {
  if (!userRoles || !targets || targets.length === 0) return false;
  return targets.some((t) => hasUserRole(userRoles, t));
};

// Convenience helpers
export const isAdmin = (userRoles: string[] | undefined): boolean => hasUserRole(userRoles, UserRoleConstants.UserAdminRole);
export const isReader = (userRoles: string[] | undefined): boolean => hasUserRole(userRoles, UserRoleConstants.UserReaderRole);
export const isEditor = (userRoles: string[] | undefined): boolean => hasUserRole(userRoles, UserRoleConstants.UserEditorRole);
export const isHandler = (userRoles: string[] | undefined): boolean => hasUserRole(userRoles, UserRoleConstants.UserHandlerRole);
